import React, { createContext, useContext, useState, useCallback } from 'react';
import { FiCheckCircle, FiXCircle, FiAlertTriangle, FiX } from 'react-icons/fi';

const ToastContext = createContext(null);

const ICONS = {
    success: <FiCheckCircle size={16} className="text-emerald-400 shrink-0" />,
    error:   <FiXCircle    size={16} className="text-red-400 shrink-0" />,
    warning: <FiAlertTriangle size={16} className="text-amber-400 shrink-0" />,
};

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    const push = useCallback((message, type = 'error') => {
        const id = Date.now();
        setToasts(t => [...t, { id, message, type }]);
        setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 4000);
    }, []);

    const remove = useCallback((id) => setToasts(t => t.filter(x => x.id !== id)), []);

    return (
        <ToastContext.Provider value={{ toast: { success: m => push(m, 'success'), error: m => push(m, 'error'), warning: m => push(m, 'warning') } }}>
            {children}
            <div className="fixed top-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
                {toasts.map(t => (
                    <div key={t.id} className="pointer-events-auto flex items-center gap-3 bg-gray-800 border border-gray-700 rounded-xl px-4 py-3 shadow-xl text-sm max-w-sm animate-in">
                        {ICONS[t.type]}
                        <span className="text-gray-200 flex-1">{t.message}</span>
                        <button onClick={() => remove(t.id)} className="text-gray-500 hover:text-gray-300 ml-1">
                            <FiX size={14} />
                        </button>
                    </div>
                ))}
            </div>
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext).toast;
